import { isNull } from 'lodash-es'

let cache = null

export default function getScrollbarSize() {
  if (!isNull(cache)) {
    return cache
  }

  if (!_isIframeDisplayed()) {
    return 0
  }

  return cache = _getScrollbarSize()
}

function _isIframeDisplayed() {
  const div = document.createElement('div')
  div.style.width = '100px'
  div.style.height = '100px'
  document.body.appendChild(div)
  const isDisplayed = true
    && div.offsetWidth !== 0
    && div.offsetHeight !== 0
  document.body.removeChild(div)
  return isDisplayed
}

function _getScrollbarSize() {
  const div1 = document.createElement('div')
  const div2 = document.createElement('div')
  div1.style.width = '100px'
  div1.style.overflowX = 'scroll'
  div2.style.width = '100px'
  document.body.appendChild(div1)
  document.body.appendChild(div2)
  const scrollbarSize = div1.offsetHeight - div2.offsetHeight
  document.body.removeChild(div1)
  document.body.removeChild(div2)
  return scrollbarSize
}
